<template>


<TopBar />

<div class="main-container">

<SideBar />

<div class="main"> 


<section>

<div class="container" style="border-bottom: solid 1px #f0f0f0; padding-top: 10px; padding-bottom: 10px;">

<div class="row">

<div class="col-md-8 pt-3">
<h3>Marsabit Weather Data</h3>
</div>



<div class="col-md-4 pt-3" style="text-align: right;">

</div>



</div>

</div>

</section>


<section style="padding-top:200px;" v-if="show_spinner==true">

<div style="text-align:center;">

<h6 class="text-secondary">Loading weather station data...</h6>
<div class="spinner-border  text-info"></div>
</div>

</section>





<section style="padding-top:20px;" v-if="show_spinner==false && today_data.air_temperature>0 ">



<div class="container" >

<div class="row">

  <div class="col-md-8">
<h6>{{title}}</h6>
</div>


<div class="col-md-4" style="text-align: right;">

<button @click="get_data()" class="btn btn-1" style="margin-right: 10px;"> <i class="bi bi-calendar-week"></i> Today</button>
<button class="btn btn-1" @click="get_yesterday_data()"> <i class="bi bi-calendar-week"></i> Yesterday</button>

</div>
  
</div>

<div class="row">


<div class="col-md-3 mt-3">

<div class="weather-card shadow">

<div class="row">

<div class="col-md-2 col-2">
<h4 class="color-1"> <i class="bi bi-cloud-sun"></i> </h4>
</div>


<div class="col-md-10 col-10">
<h6 class="text-secondary"> Temperature </h6>
<h1 class="color-1"> {{today_data.air_temperature}} <sub>oC</sub>  </h1> 
</div>

</div>


<div style="border-top: solid 1px #f0f0f0; padding-top:10px;">
<small :class="{ 'text-danger' : compare_paramters(yesterday_average_temperature, today_average_temperature) < 0, 'text-success' : compare_paramters(yesterday_average_temperature, today_average_temperature) >=0  }">
<i :class="{ 'bi bi-arrow-down' : compare_paramters(yesterday_average_temperature, today_average_temperature)<0, 'bi bi-arrow-up' : compare_paramters(yesterday_average_temperature, today_average_temperature) >=0  } "></i> {{compare_paramters(yesterday_average_temperature, today_average_temperature)}}% from yesterday
</small>
</div>

</div>

</div>






<div class="col-md-3 mt-3">

<div class="weather-card shadow">

<div class="row">

<div class="col-md-2 col-2">
<h4 class="color-1"> <i class="bi bi-droplet"></i> </h4>
</div>


<div class="col-md-10 col-10">
<h6 class="text-secondary"> Humidity </h6>
<h1 class="color-1"> {{today_data.air_humidity}} <sub>%</sub>  </h1> 
</div>

</div>


<div style="border-top: solid 1px #f0f0f0; padding-top:10px;">
<small :class="{ 'text-danger' : compare_paramters(yesterday_average_humidity, today_average_humidity)<0, 'text-success' : compare_paramters(yesterday_average_humidity, today_average_humidity)>=0 }">
<i :class=" { 'bi bi-arrow-down' : compare_paramters(yesterday_average_humidity, today_average_humidity)<0, 'bi bi-arrow-up' : compare_paramters(yesterday_average_humidity, today_average_humidity)>=0 } "></i>  {{compare_paramters(yesterday_average_humidity, today_average_humidity)}}% from yesterday
</small>
</div>

</div>

</div>




<div class="col-md-3 mt-3">

<div class="weather-card shadow">

<div class="row">

<div class="col-md-2 col-2">
<h4 class="color-1"> <i class="bi bi-water"></i> </h4>
</div>


<div class="col-md-10 col-10">
<h6 class="text-secondary"> Pressure </h6>
<h1 class="color-1"> {{today_data.barometric_pressure}} <sub>hPa</sub>  </h1> 
</div>

</div>


<div style="border-top: solid 1px #f0f0f0; padding-top:10px;">
<small :class="{ 'text-danger' : compare_paramters(yesterday_average_pressure, today_average_pressure)<0, 'text-success' : compare_paramters(yesterday_average_pressure, today_average_pressure)>=0 } ">
<i :class=" { 'bi bi-arrow-down' : compare_paramters(yesterday_average_pressure, today_average_pressure)<0, 'bi bi-arrow-up' : compare_paramters(yesterday_average_pressure, today_average_pressure)>=0  }"></i>  {{compare_paramters(yesterday_average_pressure, today_average_pressure)}}% from yesterday
</small>
</div>

</div>

</div>



<div class="col-md-3 mt-3">

<div class="weather-card shadow">

<div class="row">

<div class="col-md-2 col-2">
<h4 class="color-1"> <i class="bi bi-wind"></i> </h4>
</div>


<div class="col-md-10 col-10">
<h6 class="text-secondary"> Wind </h6>
<h1 class="color-1"> {{today_data.wind_speed}} <sub>m/s</sub>  </h1>  {{yesterday_data.wind_speed}} 
</div>

</div>


<div style="border-top: solid 1px #f0f0f0; padding-top:10px;">
<small :class=" { 'text-danger' : compare_paramters(yesterday_average_wind_speed , today_average_wind_speed)<0, 'text-success' : compare_paramters(yesterday_average_wind_speed, today_average_wind_speed)>=0 } ">
<i :class=" { 'bi bi-arrow-down' : compare_paramters(yesterday_average_wind_speed, today_average_wind_speed)<0, 'bi bi-arrow-up' : compare_paramters(yesterday_average_wind_speed, today_average_wind_speed)>=0 } "></i> {{compare_paramters(yesterday_average_wind_speed, today_average_wind_speed)}}% from yesterday
</small>
</div>

</div>

</div>



<div class="col-md-3 mt-3">

<div class="weather-card shadow">

<div class="row">

<div class="col-md-2 col-2">
<h4 class="color-1"> <i class="bi bi-brightness-high"></i> </h4>
</div>


<div class="col-md-10 col-10">
<h6 class="text-secondary"> Light Intensity </h6>
<h1 class="color-1"> {{today_data.light_intensity}} <sub>lux</sub>  </h1> 
</div>

</div>


<div style="border-top: solid 1px #f0f0f0; padding-top:10px;">
<small :class="{ 'text-danger' : compare_paramters(yesterday_average_light, today_average_light)<0, 'text-success' : compare_paramters(yesterday_average_light, today_average_light)>=0 } ">
<i :class=" { 'bi bi-arrow-down' : compare_paramters(yesterday_average_light, today_average_light)<0, 'bi bi-arrow-up' : compare_paramters(yesterday_average_light, today_average_light)>=0  }"></i>  {{compare_paramters(yesterday_average_light, today_average_light)}}% from yesterday
</small>
</div>

</div>

</div>



<div class="col-md-3 mt-3">

<div class="weather-card shadow">

<div class="row">

<div class="col-md-2 col-2">
<h4 class="color-1"> <i class="bi bi-cloud-lightning-rain"></i> </h4>
</div>


<div class="col-md-10 col-10">
<h6 class="text-secondary"> Rain </h6>
<h1 class="color-1"> {{today_data.rain_accumulation}} <sub>mm</sub>  </h1> 
</div>

</div>


<div style="border-top: solid 1px #f0f0f0; padding-top:10px;">
<small :class="{ 'text-danger' : compare_paramters(yesterday_average_rain, today_average_rain)<0, 'text-success' : compare_paramters(yesterday_average_rain, today_average_rain)>=0 } ">
<i :class=" { 'bi bi-arrow-down' : compare_paramters(yesterday_average_rain, today_average_rain)<0, 'bi bi-arrow-up' : compare_paramters(yesterday_average_rain, today_average_rain)>=0 }"></i>  {{compare_paramters(yesterday_average_rain, today_average_rain)}}% from yesterday
</small>
</div>

</div>

</div>



<div class="col-md-3 mt-3">

<div class="weather-card shadow">

<div class="row">

<div class="col-md-2 col-2">
<h4 class="color-1"> <i class="bi bi-brightness-alt-high"></i> </h4>
</div>


<div class="col-md-10 col-10">
<h6 class="text-secondary"> UV Index </h6>
<h1 class="color-1"> {{today_data.uv_index}} <sub>uvi</sub>  </h1> 
</div>

</div>


<div style="border-top: solid 1px #f0f0f0; padding-top:10px;">
<small :class="{ 'text-danger' : compare_paramters(yesterday_average_uvindex, today_average_uvindex)<0, 'text-success' : compare_paramters(yesterday_average_uvindex, today_average_uvindex)>=0 } ">
<i :class="{ 'bi bi-arrow-down' : compare_paramters(yesterday_average_uvindex, today_average_uvindex)<0, 'bi bi-arrow-up' : compare_paramters(yesterday_average_uvindex, today_average_uvindex)>=0 } "></i>  {{compare_paramters(yesterday_average_uvindex, today_average_uvindex)}}% from yesterday
</small>
</div>

</div>

</div>



<!-- trends -->

 <div class="col-md-12 mt-3">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
         Today's Temperature Trends
        </h6>





       <div>
         
         <label v-for="t in temperature_trends" style="margin:10px; text-align: center; border-bottom: solid 1px #f1f1f1; ">
           <span>{{t.label}}</span> <br />
           <i :class="{'bi bi-cloud-sun' : t.y<=30, 'bi bi-cloud-sun-fill' : t.y>30,   }" class="color-1"></i> <br />
           <span> <b>{{ t.y }}<sup>o</sup>C</b> </span>
         </label>

       </div>

       </div> 

        </div>





         <div class="col-md-12 mt-3">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
         Today's Humidity Trends
        </h6>

       <div>
         
         <label v-for="t in humidity_trends" style="margin:10px; text-align: center; border-bottom: solid 1px #f1f1f1; ">
           <span>{{t.label}}</span> <br />
           <i :class="{'bi bi-droplet' : t.y<=45, 'bi bi-droplet-fill' : t.y>45,   }" class="color-1"></i> <br />
           <span> <b>{{ t.y }}%</b> </span>
         </label>

       </div>

       </div> 

        </div>




         <div class="col-md-12 mt-3">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
         Today's Pressure Trends
        </h6>

       <div>
         
         <label v-for="t in pressure_trends" style="margin:10px; text-align: center; border-bottom: solid 1px #f1f1f1; ">
           <span>{{t.label}}</span> <br />
           <i :class="{'bi bi-water' : t.y<=3000, 'bi bi-water' : t.y>3000,   }" class="color-1"></i> <br />
           <span> <b>{{ t.y }}hPa</b> </span>
         </label>

       </div>

       </div> 

        </div>



             <div class="col-md-12 mt-3">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
         Today's Wind Trends
        </h6>

       <div>
         
         <label v-for="t in wind_trends" style="margin:10px; text-align: center; border-bottom: solid 1px #f1f1f1; ">
           <span>{{t.label}}</span> <br />
           <i :class="{'bi bi-wind' : t.y<=2, 'bi bi-wind' : t.y>2,   }" class="color-1"></i> <br />
           <span> <b>{{ t.y }}m/s</b> </span>
         </label>

       </div>

       </div> 

        </div>






             <div class="col-md-12 mt-3">

           <div class=" p-3 mt-3 shadow" style="border: solid 1px  #d7f1ff; border-radius: 15px; background-color: #fff;  ">
          <h6 class="text-secondary">
         Today's Rain Trends
        </h6>

       <div>
         
         <label v-for="t in rain_trends" style="margin:10px; text-align: center; border-bottom: solid 1px #f1f1f1; ">
           <span>{{t.label}}</span> <br />
           <i :class="{'bi bi-cloud-drizzle' : t.y<=16, 'bi bi-cloud-drizzle-fill' : t.y>17,   }" class="color-1"></i> <br />
           <span> <b>{{ t.y }}m/s</b> </span>
         </label>

       </div>

       </div> 

        </div>




</div>

</div>

</section>






</div>




</div>


<Footer />




</template>



<script>

import Header from './layouts/Header'
import SideBar from './layouts/SideBar'
import TopBar from './layouts/TopBar'
import Footer from './layouts/Footer'
import axios from 'axios'

export default{
name : 'home',
components : { Header, SideBar, TopBar, Footer  },
data(){
return{
show_spinner : true,
weather_data : [],
today_data : [],
yesterday_data : [],
today_received_at : '',
yesterday_date : '',
today_date : '',
today_average_wind_speed : 0,
yesterday_average_wind_speed : 0,
today_average_temperature : 0,
yesterday_average_temperature : 0,
today_average_humidity : 0,
yesterday_average_humidity : 0,
today_average_pressure : 0,
yesterday_average_pressure : 0,
today_average_light : 0,
yesterday_average_light : 0,
today_average_rain : 0,
yesterday_average_rain : 0,
today_average_uvindex : 0,
yesterday_average_uvindex : 0,

title : "Today's Weather",

temperature_trends : [],
humidity_trends : [],
pressure_trends : [],
wind_trends : [],
rain_trends : []



}
},

methods : {

    to_date_time(date_time) {
  const date = new Date(date_time);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date input");
  }

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  return `${hours}:${minutes} ${ampm}`;
},

compare_paramters(yesterday, today){

let diff = ((today - yesterday)/yesterday) * 100 
diff = parseFloat(diff.toFixed(1))
return diff
},

convert_to_date_only(date_time){
const dt = new Date(date_time)
const dateOnly = dt.toISOString().split('T')[0]
return dateOnly
},

get_yesterday_date(){
const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);

const year = yesterday.getFullYear();
const month = String(yesterday.getMonth() + 1).padStart(2, '0');
const day = String(yesterday.getDate()).padStart(2, '0');

const formatted = `${year}-${month}-${day}`;

return formatted
},



get_today_date(){
const today = new Date();
today.setDate(today.getDate());

const year = today.getFullYear();
const month = String(today.getMonth() + 1).padStart(2, '0');
const day = String(today.getDate()).padStart(2, '0');

const formatted = `${year}-${month}-${day}`;

return formatted
},


async get_yesterday_data() {
    this.title = "Yesterday's Weather"
this.show_spinner = true
setTimeout((data)=>{
this.show_spinner = false
}, 3000)

try {
const response = await axios.get('https://weather-data-marsabit-default-rtdb.firebaseio.com/.json')
const dataObject = response.data.weather_data
const dataArray = Object.values(dataObject)
const all_data = dataArray
const today_raw_data = dataArray.slice(100) //get last one


//get yesterday latest data 
today_raw_data.forEach((data)=>{
let received_at = this.convert_to_date_only(data.received_at)

//yesterday data
if(received_at==this.yesterday_date){
if(data.uplink_message.decoded_payload){
this.today_data = data.uplink_message.decoded_payload
}

return

}



})




//get all yesterday data
let yesterday_array_data = []
let today_array_data = []
all_data.forEach((data)=>{
let received_at = this.convert_to_date_only(data.received_at)

//get all yesterday data
if(received_at==this.yesterday_date){

if(data.uplink_message.decoded_payload){
yesterday_array_data = yesterday_array_data.concat(data.uplink_message.decoded_payload )
}

}

//get today all data

if(received_at==this.today_date){

if(data.uplink_message.decoded_payload){
today_array_data = today_array_data.concat(data.uplink_message.decoded_payload )
}

}


})

//calculate today & yesterday average data
let counter = yesterday_array_data.length
let today_counter = today_array_data.length

if(counter>0){

yesterday_array_data.forEach((data)=>{

if(data.wind_speed){
this.yesterday_average_wind_speed += parseInt(data.wind_speed)
this.yesterday_average_temperature += parseInt(data.air_temperature)
this.yesterday_average_humidity += parseInt(data.air_humidity)
this.yesterday_average_pressure += parseInt(data.barometric_pressure)
this.yesterday_average_light += parseInt(data.light_intensity)
this.yesterday_average_rain += parseInt(data.rain_accumulation)
this.yesterday_average_uvindex += parseInt(data.uv_index)
}

}) 

this.yesterday_average_wind_speed = this.yesterday_average_wind_speed/counter
this.yesterday_average_temperature = this.yesterday_average_temperature/counter
this.yesterday_average_humidity = this.yesterday_average_humidity/counter

this.yesterday_average_pressure = this.yesterday_average_pressure/counter

this.yesterday_average_light = this.yesterday_average_light/counter

this.yesterday_average_rain = this.yesterday_average_rain/counter

this.yesterday_average_uvindex = this.yesterday_average_uvindex/counter

}


//today
if(today_counter>0){

today_array_data.forEach((data)=>{

if(data.wind_speed){
this.today_average_wind_speed += parseInt(data.wind_speed)
this.today_average_temperature += parseInt(data.air_temperature)
this.today_average_humidity += parseInt(data.air_humidity)
this.today_average_pressure += parseInt(data.barometric_pressure)
this.today_average_light += parseInt(data.light_intensity)
this.today_average_rain += parseInt(data.rain_accumulation)
this.today_average_uvindex += parseInt(data.uv_index)
}

}) 

this.today_average_wind_speed = this.today_average_wind_speed/today_counter
this.today_average_temperature = this.today_average_temperature/today_counter

this.today_average_humidity = this.today_average_humidity/today_counter
this.today_average_pressure = this.today_average_pressure/today_counter

this.today_average_light = this.today_average_light/today_counter

this.today_average_rain = this.today_average_rain/today_counter

this.today_average_uvindex = this.today_average_uvindex/today_counter




}





} catch (error) {
console.log(error)
}
},



async get_data() {

  this.title = "Today's Weather"

this.show_spinner = true

/*

setTimeout((data)=>{
this.show_spinner = false
}, 5000)

*/

try {
const response = await axios.get('https://weather-data-marsabit-default-rtdb.firebaseio.com/.json')
const dataObject = response.data.weather_data
const dataArray = Object.values(dataObject)
const all_data = dataArray
const today_raw_data = dataArray.slice(-1) //get last one

const all_data_2 = dataArray.slice(-25)



//get todays latest data 
today_raw_data.forEach((data)=>{
this.today_data = data.uplink_message.decoded_payload
//console.log(data.uplink_message.decoded_payload)
this.today_received_at = this.convert_to_date_only(data.received_at) 



this.$store.state.data_last_received_at = this.to_date_time(data.received_at)
localStorage.setItem('data_last_received_at', this.$store.state.data_last_received_at )

})





//temperature trends
//signal strength trends 
let temperature_trends = []
let humidity_trends = []
let pressure_trends = []
let wind_trends = []
let rain_trends = []
all_data_2.forEach((data)=>{
//temperature_trends.push(data.uplink_message.decoded_payload)
  try{
    if(this.get_today_date()==this.convert_to_date_only(data.received_at)){
       temperature_trends.push( { 'y' : data.uplink_message.decoded_payload.air_temperature, 'label' :  this.to_date_time(data.received_at)  } )

       humidity_trends.push( { 'y' : data.uplink_message.decoded_payload.air_humidity, 'label' :  this.to_date_time(data.received_at)  } )

       pressure_trends.push( { 'y' : data.uplink_message.decoded_payload.barometric_pressure, 'label' :  this.to_date_time(data.received_at)  } )

         wind_trends.push( { 'y' : data.uplink_message.decoded_payload.wind_speed, 'label' :  this.to_date_time(data.received_at)  } )


         rain_trends.push( { 'y' : data.uplink_message.decoded_payload.rain_accumulation, 'label' :  this.to_date_time(data.received_at)  } )


    }
   

  }catch(error){
    //
  }

 
})

this.temperature_trends = temperature_trends

this.humidity_trends = humidity_trends
this.pressure_trends = pressure_trends
this.wind_trends = wind_trends
this.rain_trends = rain_trends




//get all yesterday data
let yesterday_array_data = []
let today_array_data = []
all_data.forEach((data)=>{
let received_at = this.convert_to_date_only(data.received_at)

//get all yesterday data
if(received_at==this.yesterday_date){

if(data.uplink_message.decoded_payload){
yesterday_array_data = yesterday_array_data.concat(data.uplink_message.decoded_payload )
}

}

//get today all data

if(received_at==this.today_date){

if(data.uplink_message.decoded_payload){
today_array_data = today_array_data.concat(data.uplink_message.decoded_payload )
}

}


})

//calculate today & yesterday average data
let counter = yesterday_array_data.length
let today_counter = today_array_data.length

if(counter>0){

yesterday_array_data.forEach((data)=>{

if(data.wind_speed){
this.yesterday_average_wind_speed += parseInt(data.wind_speed)
this.yesterday_average_temperature += parseInt(data.air_temperature)
this.yesterday_average_humidity += parseInt(data.air_humidity)
this.yesterday_average_pressure += parseInt(data.barometric_pressure)
this.yesterday_average_light += parseInt(data.light_intensity)
this.yesterday_average_rain += parseInt(data.rain_accumulation)
this.yesterday_average_uvindex += parseInt(data.uv_index)
}

}) 

this.yesterday_average_wind_speed = this.yesterday_average_wind_speed/counter
this.yesterday_average_temperature = this.yesterday_average_temperature/counter
this.yesterday_average_humidity = this.yesterday_average_humidity/counter

this.yesterday_average_pressure = this.yesterday_average_pressure/counter

this.yesterday_average_light = this.yesterday_average_light/counter

this.yesterday_average_rain = this.yesterday_average_rain/counter

this.yesterday_average_uvindex = this.yesterday_average_uvindex/counter

}


//today
if(today_counter>0){

today_array_data.forEach((data)=>{

if(data.wind_speed){
this.today_average_wind_speed += parseInt(data.wind_speed)
this.today_average_temperature += parseInt(data.air_temperature)
this.today_average_humidity += parseInt(data.air_humidity)
this.today_average_pressure += parseInt(data.barometric_pressure)
this.today_average_light += parseInt(data.light_intensity)
this.today_average_rain += parseInt(data.rain_accumulation)
this.today_average_uvindex += parseInt(data.uv_index)
}

}) 

this.today_average_wind_speed = this.today_average_wind_speed/today_counter
this.today_average_temperature = this.today_average_temperature/today_counter

this.today_average_humidity = this.today_average_humidity/today_counter
this.today_average_pressure = this.today_average_pressure/today_counter

this.today_average_light = this.today_average_light/today_counter

this.today_average_rain = this.today_average_rain/today_counter

this.today_average_uvindex = this.today_average_uvindex/today_counter




}



this.show_spinner = false


} catch (error) {
console.log(error)
}


}



},

created(){
this.today_date = this.get_today_date()
this.yesterday_date = this.get_yesterday_date()

this.get_data()

setTimeout((data)=>{
this.get_data()
}, 600000)





}


}

</script>

